export default __webpack_public_path__ + "static/media/voucherAddition1.02a263af.jpg";